<script>
import cityCodeData from '@/assets/city_code.json';
import {Message} from "element-ui";
import {categoryTree, deviceInfo} from "@/api";
import {getUserPermissions, saveOrUpdateUserPermissions} from "@/api/user";

export default {
  name: 'UserBind',
  data() {
    return {
      visible: false,
      deviceVisible : false,
      account: {},
      bindForm : {
        cityPath : []
      },
      cityTreeData : [],
      categories: [],
      devices : [],
      selectionIds : [],
      selectedIds : [],
      currentPage: 1,
      pageSize: 100,
      total: 0,
      defaultProps: {
        children: 'children',
        label: 'value',
        value: 'code',
      },
      categoryProps: {
        children: 'child',
        label: 'name',
        value: 'id',
      },
    }
  },
  async mounted() {
    await this.loadCityData();

  },
  methods: {
    async open(data) {
      this.visible = true
      this.account = data;
      await this.fetchUserPermission()
      await this.fetchTopCategory()
    },
    // 加载城市代码数据
    async loadCityData() {
      try {
        this.cityTreeData = cityCodeData
      } catch (error) {
        console.error('加载城市数据失败:', error);
        Message.error('加载城市数据失败');
      }
    },
    async fetchTopCategory(){
      const res = await categoryTree()
      if (res && res.code === "0000" && res.result && res.result.length > 0){
        this.categories = this.mergeCategoriesToChild(res.result) || []
      }
    },

    async fetchUserPermission(){
      const res = await getUserPermissions(this.account.id)
      if (res && res.code === "0000" ){
        this.bindForm = {
          ...this.bindForm,
          ...res.result
        }
        this.selectedIds = res.result.equipmentIds || []
      }else {
        Message.error("查询结果异常")
      }

    },

    async submit(){
      if (!this.account){
        Message.warning("用户信息丢失")
        return
      }
      console.log("提交参数", this.bindForm)
      const param = {
        ...this.bindForm,
        regionCodes : this.bindForm.cityPath,
        category : this.bindForm.categoryIds && this.bindForm.categoryIds.length > 0 ? this.getSelectedThirdLevelCategories(this.bindForm.categoryIds) : null,
        accountId : this.account.id,
        equipmentIds : this.selectedIds,
      }
      console.log('submit:', param)

      const res = await  saveOrUpdateUserPermissions(param)
      if (res && res.code === "0000") {
        this.visible = false;
        Message.success(`操作成功`)
      }
    },


    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 当页面大小改变时，重置到第一页
      this.deviceList()
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.deviceList()
    },

    changeCity(value) {
      this.bindForm.cityPath = value
    },

    mergeCategoriesToChild(items) {
      return items.map(item => {
        const processedItem = { ...item };

        // 处理现有的child节点
        if (item.child && Array.isArray(item.child)) {
          processedItem.child = this.mergeCategoriesToChild(item.child);
        }

        // 将categories数组添加到child中
        if (item.categories && Array.isArray(item.categories) && item.categories.length > 0) {
          const categoriesAsChildren = item.categories.map(cat => ({
            ...cat,
            child: null  // categories项本身没有更深层级
          }));

          // 如果已有child，则合并；否则直接赋值
          if (processedItem.child && Array.isArray(processedItem.child)) {
            processedItem.child = [...processedItem.child, ...categoriesAsChildren];
          } else {
            processedItem.child = categoriesAsChildren;
          }
        }

        return processedItem;
      });
    },

    // 获取选中的第三层分类ID
    getSelectedThirdLevelCategories(paths) {
      const selectedPaths = paths.map(path => path.map(Number));
      const resultIds = [];

      selectedPaths.forEach(path => {
        if (path.length === 1) {
          // 如果选中的是第一层，获取其第二层的所有子分类ID
          const firstLevelId = path[0];
          const firstLevelCategory = this.findCategoryById(this.categories, firstLevelId);
          if (firstLevelCategory && firstLevelCategory.child) {
            firstLevelCategory.child.forEach(secondLevel => {
              if (secondLevel.child) {
                // 添加第二层下的所有第三层分类ID
                secondLevel.child.forEach(thirdLevel => {
                  resultIds.push(thirdLevel.id);
                });
              }
            });
          }
        } else if (path.length === 2) {
          // 如果选中的是第二层，获取其所有第三层子分类ID
          const [firstLevelId, secondLevelId] = path;
          const firstLevelCategory = this.findCategoryById(this.categories, firstLevelId);
          if (firstLevelCategory) {
            const secondLevelCategory = this.findCategoryById(firstLevelCategory.child, secondLevelId);
            if (secondLevelCategory && secondLevelCategory.child) {
              secondLevelCategory.child.forEach(thirdLevel => {
                resultIds.push(thirdLevel.id);
              });
            }
          }
        } else if (path.length === 3) {
          // 如果选中的是第三层，直接使用该ID
          resultIds.push(path[2]);
        }
      });

      return [...new Set(resultIds)]; // 去重并返回
    },

    // 辅助方法：根据ID查找分类
    findCategoryById(categories, id) {
      if (!categories || !Array.isArray(categories)) return null;

      for (const category of categories) {
        if (category.id === id) {
          return category;
        }
        if (category.child && category.child.length > 0) {
          const found = this.findCategoryById(category.child, id);
          if (found) return found;
        }
      }
      return null;
    },

    changeCategory(value) {
      this.bindForm.categoryIds = value;
    },

    validFormat(row,column){
      let value =  row[column.property]
      return value && value.length > 10 ? value.substring(0, 10) : '-';
    },

    async openDevice() {
      this.deviceVisible = true;
      await this.deviceList()
    },

    async deviceList() {
      try {
        let list = {
          "filter": [
            /*{
              "name": "name",
              "value": this.searchKeyword,
              "type": "LIKE"
            },
            {
              "name": "code",
              "value": this.searchKeywordCode,
              "type": "LIKE"
            }*/
          ],
          current: this.currentPage,
          size: this.pageSize,
        }
        const res = await deviceInfo(list)
        this.devices = res.result.records || []; // 确保有默认空数组
        this.total = res.result.total;
        // 数据加载完成后同步选中状态
        this.$nextTick(() => {
          this.syncSelectionAfterPageChange();
        });
      } catch (error) {
        console.error(error)
        this.devices = []; // 出错时重置为空数组
      }
    },

    handleSelectionChange(val) {
      this.selectedIds = val.map(item => item.id)
      // 保存当前页选中的行对象
      this.selectionIds = val;
    },
    // 在切换分页后同步选中状态的方法
    syncSelectionAfterPageChange() {
      this.$nextTick(() => {
        // 清除当前页面的选中状态
        this.$refs.deviceTable.clearSelection();
        // 为每个已选中的行设置选中状态
        this.devices.forEach(row => {
          if (this.selectedIds.includes(row.id)) {
            this.$refs.deviceTable.toggleRowSelection(row, true);
          }
        });
      });
    },
  },

}

</script>

<template>
  <div>
    <el-dialog title="用户绑定资源" :visible.sync="visible" >
      <div style="display: flex; flex-direction: column; gap: 20px; height: 60vh;">
        <el-tabs style="flex: 1">
          <el-tab-pane label="设备列表">
            <el-form label-width="80" >
              <el-form-item label="绑定设备" prop="deviceIds">
                <el-button type="primary" size="small" @click="openDevice">添加</el-button>
              </el-form-item>
              <el-form-item prop="id" />
              <el-form-item prop="accountId" />
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="区域">
            <el-form label-width="120">
              <el-form-item label="绑定区域" prop="cityPath" style="width: 100%">
                <el-cascader
                    v-model="bindForm.cityPath"
                    :options="cityTreeData"
                    :props="{ expandTrigger: 'hover', checkStrictly: true,  multiple: true , ...defaultProps}"
                    placeholder="搜索/选择城市层级"
                    filterable
                    clearable
                    @change="changeCity"
                    style="width: 80%"
                />
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="设备分类">
            <el-form label-width="120">
              <el-form-item label="设备分类" prop="category" style="width: 100%">
                <el-cascader
                    v-model="bindForm.categoryIds"
                    :options="categories"
                    :props="{ expandTrigger: 'hover', checkStrictly: true,  multiple: true , ...categoryProps}"
                    placeholder="搜索/选择城市层级"
                    filterable
                    clearable
                    @change="changeCategory"
                    style="width: 80%"
                />
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <el-row type="flex" justify="end">
          <el-button type="primary" @click="submit">确定</el-button>
        </el-row>
      </div>
    </el-dialog>

    <el-drawer title="设备列表" :visible.sync="deviceVisible" size="80%"   direction="btt">
      <el-card shadow="never">
        <el-table
            :data="devices" border
            @selection-change="handleSelectionChange"
            tooltip-effect="dark"
            row-key="id"
            current-row-key="id"
            ref="deviceTable"
            stripe highlight-current-row
        >
          <el-table-column type="selection" width="55"/>
          <el-table-column prop="id" label="设备ID" width="200" fixed />
          <el-table-column prop="code" label="设备编码" width="200" />
          <el-table-column prop="name" label="设备名称" show-overflow-tooltip width="200" />
          <el-table-column prop="validStart" label="开始时间" :formatter="validFormat" />
          <el-table-column prop="validEnd" label="到期时间" :formatter="validFormat" />
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                         :page-sizes="[50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                         :total="total" class="pagination"></el-pagination>
        </div>
      </el-card>
    </el-drawer>
  </div>
</template>

<style scoped>

</style>
